module.exports = __webpack_public_path__ + "static/media/8.f954a332.jpg";